import {
  IoImageOutline,
  IoMailOutline,
  IoGiftOutline,
  IoSendOutline,
} from 'react-icons/io5';
import { QuickActionTile } from './QuickActionTile';

/**
 * The 4-tile "what do you want to send?" grid on Home.
 *
 * Layout:
 *   - mobile (<640): 2×2 grid
 *   - sm+ (≥640):    4×1 row
 *
 * Each tile routes into its product flow. For v1 those routes render
 * ComingSoonPage placeholders until PEL-825 / 826 / 827 / 828 ship.
 */
export function QuickActionGrid() {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
      <QuickActionTile
        to="/app/products/photos"
        icon={IoImageOutline}
        label="Send photos"
        helper="Up to 4 per order"
        accent="brand"
      />
      <QuickActionTile
        to="/app/products/letters"
        icon={IoMailOutline}
        label="Send a letter"
        helper="Typed or handwritten"
        accent="cta"
      />
      <QuickActionTile
        to="/app/products/cards"
        icon={IoGiftOutline}
        label="Send a card"
        helper="Birthday, holiday, more"
        accent="brand"
      />
      <QuickActionTile
        to="/app/products/postcards"
        icon={IoSendOutline}
        label="Send a postcard"
        helper="Single-sided keepsake"
        accent="cta"
      />
    </div>
  );
}
